// extracted by mini-css-extract-plugin
export default {"control":"control--LO_Rv","maxHeight":"maxHeight--h3NhX"};